import { useIncludes } from '@uswitch/ev-utils/context/selectors';
import { sortByDate } from '@uswitch/ev-utils/dates';
export var useCategoryGuides = function useCategoryGuides(_ref) {
  var _ref$guides = _ref.guides,
      guides = _ref$guides === void 0 ? [] : _ref$guides,
      pathname = _ref.pathname;
  var includes = useIncludes();
  var filteredGuides = guides.filter(function (_ref2) {
    var _ref2$fields = _ref2.fields;
    _ref2$fields = _ref2$fields === void 0 ? {} : _ref2$fields;
    var url = _ref2$fields.url;
    return pathname && url ? pathname !== url : true;
  }).filter(function (guide) {
    var _guide$fields, _guide$fields$variant, _guide$fields2, _guide$fields$link;

    if (guide !== null && guide !== void 0 && (_guide$fields = guide.fields) !== null && _guide$fields !== void 0 && (_guide$fields$variant = _guide$fields.variants) !== null && _guide$fields$variant !== void 0 && _guide$fields$variant.length) return includes[guide.fields.variants[0].sys.id];else if (guide !== null && guide !== void 0 && (_guide$fields2 = guide.fields) !== null && _guide$fields2 !== void 0 && _guide$fields2.entry) return includes[guide.fields.entry.sys.id];else return includes[(_guide$fields$link = guide.fields.link) === null || _guide$fields$link === void 0 ? void 0 : _guide$fields$link.sys.id];
  }).sort(sortByDate);
  return filteredGuides;
};
//# sourceMappingURL=use-category-guides.js.map